var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToolsCorners(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 977 1440",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ToolsCorners-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0-corners { fill: none;stroke: #00529a;stroke-width: 2 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-corners",
    d: "m937.6 1165.3l34 290.9-186.5-731.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-corners",
    d: "m634.6 1265.4l337 190.8-529.1-43.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-corners",
    d: "m442.5 725.5l529.1 730.7-643-190.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-corners",
    d: "m440.5 140.1l531.1 1316.1-222.6-425.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-corners",
    d: "m785.1 1019.4l-799.5 436.8 187.4-143.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-corners",
    d: "m366.4 1413.1l-380.8 43.1 724.7-190.8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-corners",
    d: "m288.6 1019.1l-298.3 431.7 488.3-871.1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-corners",
    d: "m328.6 724.3l-338.3 726.5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-corners",
    d: "m971.6 338.4l-986 1117.8 113.4-533.5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-corners",
    d: "m99 234.9l-113.4 1221.3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-corners",
    d: "m862.5 285l-876.9-291.9 417.3 98.2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-corners",
    d: "m478.6 338.4l-493-345.3 303.2 147"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-corners",
    d: "m521.6 674.3l-536-681.2 724.7 635.7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-corners",
    d: "m248.7 579.7l-263.1-586.6 570 1022.1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-corners",
    d: "m137.1 915.9l-151.5-922.8 417.3 1272.3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-corners",
    d: "m710.3-6.9l261.3 1463.1-949.3-827.4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-corners",
    d: "m826 536l145.6-542.9-70.8 732.4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-corners",
    d: "m288.8 1214.6l682.8-1221.5-109.1 241.8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-corners",
    d: "m484 381.6l487.6-388.5-261.3 388.5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-corners",
    d: "m137.1 189.5l834.5-196.4-722.5 291.9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-corners",
    d: "m177.1 39l794.5-45.9-834.5 878.1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsCorners);
export default __webpack_public_path__ + "static/media/ToolsCorners.87c04591b17319b015c2101e90f4384f.svg";
export { ForwardRef as ReactComponent };